import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';
import SectionLayout from '../../components/SectionLayout/SectionLayout';
import SkillsSlider from '../../components/Skills/SkillsSlider';
import Loader from '../../components/Loader';

const ProjectPage = ({ lang = "es" }) => {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProject = async () => {
      setLoading(true);
      const q = query(
        collection(db, 'projects'),
        where('image', '==', id),
        where('lang', '==', lang)
      );
      const snap = await getDocs(q);
      snap.forEach(doc => console.log(doc.data()));
      if (!snap.empty) {
        setProject({ id: snap.docs[0].id, ...snap.docs[0].data() });
      } else {
        setProject(null);
      }
      setLoading(false);
    };
    fetchProject();
  }, [id, lang]);

  if (loading) return <Loader text={lang === 'en' ? 'Loading' : 'Cargando'}/>;
  if (!project) return <div>Project not found</div>;

  const { title, description, image, longDescription, technologies } = project;

  return (
    <div className="project-page">
      {/* Sección 1: Nombre del proyecto y pequeña descripción */}
      <section className="project-page__hero">
        <div className="project-page__hero-content">
          <h1 className="project-page__hero-title">{title}</h1>
          <p className="project-page__hero-description">{description}</p>
        </div>
      </section>

      {/* Sección 2: Project Overview */}
      <SectionLayout id="project-overview" title="Project Overview">
        <div className="project-page__overview">
          <div className="project-page__overview-img-cont">
            {image && (
              <img
                src={image.startsWith('http') ? image : require(`../../assets/png/${image}.png`)}
                alt={title}
                className="project-page__overview-img"
              />
            )}
          </div>
          <div className="project-page__overview-desc">
            <p>{longDescription}</p>
          </div>
        </div>
      </SectionLayout>

      {/* Sección 3: Tecnologías usadas */}
      <SectionLayout id="technologies-used" title="Technologies Used">
        <SkillsSlider skills={technologies} />
      </SectionLayout>
    </div>
  );
};

export default ProjectPage;